import React from 'react';
import { shape } from 'prop-types';
import { Grid, Divider, Popup } from 'semantic-ui-react';
import dayjs from 'dayjs';
import Copy from 'Assets/icons/copy.svg';
import SystemX from 'Assets/icons/system-x.svg';
import { CERT_VOIDED_STATUS } from 'Constants/commons';

import styles from './styles.less';
import LineInfo from './LineInfo';

const DATE_FORMAT = 'DD MMM, YYYY';
const DATE_TIME_FORMAT = 'DD MMM YYYY, HH:mm';

const renderDate = (date, format = DATE_FORMAT) => {
  if (!date || !dayjs(date).isValid()) return '-';

  return dayjs(date).format(format);
};

const MCDigiPreviewContent = ({ certDetail }) => {
  if (!certDetail) {
    return null;
  }

  const digiFileUrl = certDetail.digiFileUrl || '';

  const typeText = `${certDetail.digiTypeDetail?.name || '---'} • ${
    certDetail.digiTypeDetail?.description || ''
  }`;

  const unfitText = `${certDetail.days || '---'} days • From: ${renderDate(
    certDetail.unfitFrom,
  )} - To: ${renderDate(certDetail.unfitTo)}`;

  const fitForLightDutyText = `From: ${renderDate(certDetail.fitFrom)} - To: ${renderDate(
    certDetail.fitTo,
  )}`;

  const copyToClipboard = value => {
    navigator.clipboard.writeText(value);
  };

  return (
    <Grid>
      {certDetail.status === CERT_VOIDED_STATUS && (
        <div className={styles.voidWrapper}>
          <img alt="void" src={SystemX} />
          This DigiMC has been voided.
        </div>
      )}
      <LineInfo
        label={<div className={styles.linkTitleWrapper}>Link</div>}
        value={
          <div className={styles.linkWrapper}>
            <a href={digiFileUrl} target="_blank" rel="noreferrer">
              {digiFileUrl}
            </a>
            <Popup
              trigger={
                <img
                  alt="copy"
                  src={Copy}
                  style={{ cursor: 'pointer' }}
                  onClick={() => copyToClipboard(digiFileUrl)}
                />
              }
              on="click"
              content="Copied!"
            />
          </div>
        }
      />
      <LineInfo label="Patient Name" value={certDetail.patientName || '---'} />
      <LineInfo label="NRIC/Passport Number" value={certDetail.patientNric || '---'} />
      <Divider className={styles.fullWidth} />
      <LineInfo label="Type" value={typeText} />
      <LineInfo label="Unfit for Duty" value={unfitText} />
      {!!certDetail.fitFrom && !!certDetail.fitTo && (
        <LineInfo label="Fit for Light Duty" value={fitForLightDutyText} />
      )}
      <LineInfo
        label="Comment"
        value={<div className={styles.commentWrapper}>{certDetail.comments || '---'}</div>}
      />
      <Divider className={styles.fullWidth} />
      <LineInfo label="Issued At" value={renderDate(certDetail.issueDate, DATE_TIME_FORMAT)} />
      <LineInfo label="Issued By" value={certDetail.doctorInfo?.name || '---'} />
      <LineInfo label="Clinic" value={certDetail.clinicInfo?.name || '---'} />
      <Divider hidden style={{ margin: 8 }} />
    </Grid>
  );
};

MCDigiPreviewContent.propTypes = {
  certDetail: shape({}),
};

export default MCDigiPreviewContent;
